<template>
  <div class="banner">
    <div class="page_padding top-banner">
      <span class="banner-title fontBold">{{ subTitle }}</span>
      <image-component
        v-if="subImg !== undefined"
        path=""
        :is_jpg="false"
        :name="subImg"
      ></image-component>
    </div>
  </div>
</template>

<script>
import ImageComponent from "./imageComponent.vue";
export default {
  components: {ImageComponent},
  props: {
    subTitle: String,
    subImg: String,
  },

  methods: {
    checkMobileWidth() {
      return window.innerWidth > 767;
    },
  },
};
</script>

<style>
@import url("../assets/source/css/style.css");
.banner {
  background-color: #f8f8f8;
}
.top-banner {
  width: 100%;
  padding-top: 71px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: max-content;
  box-sizing: border-box;
  height: 100%;
}

.banner-title {
  font-size: 2rem;
  word-break: keep-all;
}
</style>
<style scoped>
.top-banner >>> img {
  display: block;
}
</style>
